import styled from 'styled-components'

export const BigLabel = styled.span`
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
`
